import { createActionCreator } from 'deox'
import {
  BottomNavButton,
  DismissableModal,
  MiscUI,
  Plan,
  ReferralProject,
} from '../../types/reducerTypes'
import { o } from 'ramda'

export const setHeaderBgUrl = createActionCreator(
  'SET_HEADER_BG_URL',
  (resolve) => (url: string) => resolve(url),
)

export const setShowHeaderGradient = createActionCreator(
  'SET_SHOW_HEADER_GRADIENT',
  (resolve) => (shouldShow: boolean) => resolve(shouldShow),
)

export const setPageBgUrl = createActionCreator(
  'SET_PAGE_BG_URL',
  (resolve) => (url: string) => resolve(url),
)

export const setHideBurger = createActionCreator(
  'SET_HIDE_BURGER',
  (resolve) => (hideBurger: boolean) => resolve(hideBurger),
)

export const setIsDarkThemeState = createActionCreator(
  'SET_UI_THEME',
  (resolve) => (isDark: boolean) => resolve(isDark),
)

export const setTopBarContent = createActionCreator(
  'SET_TOP_BAR_CONTENT',
  (resolve) => (topBarContent: string | null) => resolve(topBarContent),
)

export const setTopBarUrlLink = createActionCreator(
  'SET_TOP_BAR_URL_LINK',
  (resolve) => (topBarUrlLink: string | null) => resolve(topBarUrlLink),
)

export const setTopBarRightContent = createActionCreator(
  'SET_TOP_BAR_RIGHT_CONTENT',
  (resolve) => (topBarRightContent: boolean) => resolve(topBarRightContent),
)

export const setTopBarHideMobile = createActionCreator(
  'SET_TOP_BAR_HIDE_MOBILE',
  (resolve) => (topBarHideMobile: boolean) => resolve(topBarHideMobile),
)

export const setAllPoolsLastPage = createActionCreator(
  'SET_ALL_POOLS_LAST_PAGE',
  (resolve) => (allPoolsLastPage: number) => resolve(allPoolsLastPage),
)

export const setShouldScrollToProjects = createActionCreator(
  'SET_SHOULD_SCROLL_TO_PROJECTS',
  (resolve) => (shouldScrollToProjects: boolean) =>
    resolve(shouldScrollToProjects),
)

export const setShouldResetRewardsNotification = createActionCreator(
  'SET_SHOULD_RESET_REWARDS_NOTIFICATION',
  (resolve) => (shouldResetRewardsNotification: boolean) =>
    resolve(shouldResetRewardsNotification),
)

export const setMultiStepTxTotalSteps = createActionCreator(
  'SET_SHOULD_MULTI_STEP_TX_TOTAL_STEPS',
  (resolve) => (multiStepTxTotalSteps: number) =>
    resolve(multiStepTxTotalSteps),
)

export const setMultiStepTxCurrentStep = createActionCreator(
  'SET_SHOULD_MULTI_STEP_TX_CURRENT_STEP',
  (resolve) => (multiStepTxCurrentStep: number) =>
    resolve(multiStepTxCurrentStep),
)

export const setAllocationOpenTabs = createActionCreator(
  'SET_ALLOCATION_OPEN_TABS',
  (resolve) => (allocationOpenTabs: number[]) => resolve(allocationOpenTabs),
)

export const setResetAllClaims = createActionCreator(
  'SET_RESET_ALL_CLAIMS',
  (resolve) => (resetAllClaims: boolean) => resolve(resetAllClaims),
)

export const setAllocationIndexClaiming = createActionCreator(
  'SET_ALLOCATION_INDEX_CLAIMING',
  (resolve) => (allocationIndexClaiming: number) =>
    resolve(allocationIndexClaiming),
)

export const setInvestmentAmountForCheckout = createActionCreator(
  'SET_INVESTMENT_AMOUNT_FOR_CHECKOUT',
  (resolve) => (investmentAmountForCheckout: number) =>
    resolve(investmentAmountForCheckout),
)

export const setIsCheckoutScreen = createActionCreator(
  'SET_IS_CHECKOUT_SCREEN',
  (resolve) => (isCheckoutScreen: boolean) => resolve(isCheckoutScreen),
)

export const setPlanForCheckout = createActionCreator(
  'SET_INVESTMENT_AMOUNT_FOR_CHECKOUT',
  (resolve) => (planForCheckout: Plan) => resolve(planForCheckout),
)

export const setHasCompletedPlusCheckout = createActionCreator(
  'SET_HAS_COMPLETED_PLUS_CHECKOUT',
  (resolve) => (hasCompletedPlusCheckout: boolean) =>
    resolve(hasCompletedPlusCheckout),
)

export const setShowRadialGlow = createActionCreator(
  'SET_SHOW_RADIAL_GLOW',
  (resolve) => (showRadialGlow: boolean) => resolve(showRadialGlow),
)

export const setRewardsAmount = createActionCreator(
  'SET_REWARDS_AMOUNT',
  (resolve) => (rewardsAmount: number) => resolve(rewardsAmount),
)

export const setHeaderHeight = createActionCreator(
  'SET_HEADER_HEIGHT',
  (resolve) => (headerHeight: number) => resolve(headerHeight),
)

export const setIsLaunch = createActionCreator(
  'SET_IS_LAUNCH',
  (resolve) => (isLaunch: boolean) => resolve(isLaunch),
)

export const setIsMemecoins = createActionCreator(
  'SET_IS_MEMECOINS',
  (resolve) => (isMemecoins: boolean) => resolve(isMemecoins),
)

export const setMemecoinsSearchQuery = createActionCreator(
  'SET_MEMECOINS_SEARCH_QUERY',
  (resolve) => (searchQuery: string) => resolve(searchQuery),
)

export const setIsDrops = createActionCreator(
  'SET_IS_DROPS',
  (resolve) => (isDrops: boolean) => resolve(isDrops),
)

export const setShouldShowDashboardHeaderGradient = createActionCreator(
  'SET_SHOW_DASHBOARD_HEADER_GRADIENT',
  (resolve) => (shouldShow: boolean) => resolve(shouldShow),
)

export const setReferralProject = createActionCreator(
  'SET_REFERRAL_PROJECT',
  (resolve) => (referralProject: MiscUI['referralProject']) =>
    resolve(referralProject),
)

export const setReferralProjectData = createActionCreator(
  'SET_REFERRAL_PROJECT_DATA',
  (resolve) => (data: ReferralProject) => resolve(data),
)

export const setReferralProjectLoading = createActionCreator(
  'SET_REFERRAL_PROJECT_LOADING',
  (resolve) => (isLoading: boolean) => resolve(isLoading),
)

export const setReferralProjectError = createActionCreator(
  'SET_REFERRAL_PROJECT_ERROR',
  (resolve) => (isError: boolean) => resolve(isError),
)

export const setTwitterWarningNotice = createActionCreator(
  'SET_TWITTER_WARNING_NOTICE',
  (resolve) => (twitterWarningNotice: string | null) =>
    resolve(twitterWarningNotice),
)

export const setDiscordWarningNotice = createActionCreator(
  'SET_DISCORD_WARNING_NOTICE',
  (resolve) => (discordWarningNotice: string | null) =>
    resolve(discordWarningNotice),
)

export const setBottomNavButton = createActionCreator(
  'SET_BOTTOM_NAV_BUTTON',
  (resolve) => (bottomNavButton: BottomNavButton | null) =>
    resolve(bottomNavButton),
)

export const setDismissableModal = createActionCreator(
  'SET_DISMISSABLE_MODAL',
  (resolve) => (dismissableModal: DismissableModal | null) =>
    resolve(dismissableModal),
)
